import React from "react";
import PropTypes from "prop-types";
import { CsmArticleContent, CsmArticleMeta } from ".";
import { generateArticleUrl, imageResizeBaseUrl } from "./../../utilities.js";
import "./csmArticle.css";
import { getProp } from "../../utilities";

class CsmArticle extends React.Component {
  render() {
    let img = getProp(this.props.content, "picture.uri", null);
    if (img !== null) {
      img = `${imageResizeBaseUrl(1000)}/${img}`;
    }

    try {
      return (
        <article className="article-container">
          {this.props.displayMeta && (
            <CsmArticleMeta
              creationDate={this.props.content.date}
              authorName={getProp(this.props.content, "author.name", null)}
              authorPicture={getProp(
                this.props.content,
                "author.picture",
                null
              )}
              shareUrl={`${process.env.REACT_APP_BASE_URL}${generateArticleUrl(
                this.props.content
              )}`}
              shareTitle={this.props.content.name}
              sharePicture={img}
              allowShare={this.props.preview === false}
            />
          )}
          <CsmArticleContent
            canonicalUrl={this.props.canonicalUrl}
            allowComments={this.props.allowComments}
            content={this.props.content}
          />
        </article>
      );
    } catch (e) {
      console.error(e);
    }
  }
}

CsmArticle.defaultProps = {
  displayMeta: true,
  allowComments: false,
  preview: false
};

CsmArticle.propTypes = {
  content: PropTypes.object.isRequired,
  displayMeta: PropTypes.bool,
  allowComments: PropTypes.bool,
  canonicalUrl: PropTypes.string,
  preview: PropTypes.bool
};

export default CsmArticle;



// WEBPACK FOOTER //
// ./src/ui/src/component/csmArticle/csmArticle.js